// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */
// @ts-nocheck
import type * as Types from '@/graphql/schema';

import useSubscription from '@/client/hooks/useSubscription';
import gql from '@/graphql/gql';
export type NftDropRewardNotificationAddedSubscriptionVariables = Types.Exact<{
  input: Types.CasinoNotificationModalNotificationAddedSubscriptionInput;
}>;


export type NftDropRewardNotificationAddedSubscription = { __typename?: 'Subscription', nftDropRewardNotificationAdded?: { __typename?: 'CasinoNotificationModalNotificationAddedSubscriptionPayload', clientSubscriptionId?: string, addedNotification?: { __typename?: 'CasinoNotificationNotificationEdge', node?: { __typename?: 'CasinoNotificationDataSolutionsNotification' } | { __typename?: 'CasinoNotificationDeposit' } | { __typename?: 'CasinoNotificationFirstNotification' } | { __typename?: 'CasinoNotificationFreebetsReward' } | { __typename?: 'CasinoNotificationKycNotification' } | { __typename?: 'CasinoNotificationRewardActivated' } | { __typename?: 'CasinoNotificationRewardForfeited' } | { __typename?: 'CasinoNotificationRewardReleased' } | { __typename?: 'CasinoNotificationSteamTrade' } | { __typename?: 'CasinoNotificationUserBadgeNotification' } | { __typename?: 'CasinoNotificationUserModalNotification', id: string, userId?: string, isRead?: boolean, eventTime?: number, createTime?: number, articleHandle?: string, articleSection?: string } | { __typename?: 'CasinoNotificationUserNotification' } | { __typename?: 'CasinoNotificationUserVideoNotification' } | { __typename?: 'CasinoNotificationWithdraw' } } } };

export type NftRewardNotificationFragment = { __typename?: 'CasinoNotificationUserModalNotification', id: string, userId?: string, isRead?: boolean, eventTime?: number, createTime?: number, articleHandle?: string, articleSection?: string };

export const NftRewardNotificationFragmentDoc = gql`
    fragment NftRewardNotificationFragment on CasinoNotificationUserModalNotification {
  id
  userId
  isRead
  eventTime
  createTime
  articleHandle
  articleSection
}
    `;
export const NftDropRewardNotificationAddedSubscriptionDocument = gql`
    subscription NftDropRewardNotificationAddedSubscription($input: CasinoNotificationModalNotificationAddedSubscriptionInput!) {
  nftDropRewardNotificationAdded: casinoNotificationModalNotificationAdded(
    input: $input
  ) {
    addedNotification {
      node {
        ...NftRewardNotificationFragment
      }
    }
    clientSubscriptionId
  }
}
    ${NftRewardNotificationFragmentDoc}`;

export const useNftDropRewardNotificationAddedSubscription = (options: { variables?: NftDropRewardNotificationAddedSubscriptionVariables, onData: (data: NftDropRewardNotificationAddedSubscription) => void } ) => { 
  return useSubscription<NftDropRewardNotificationAddedSubscription, NftDropRewardNotificationAddedSubscriptionVariables>(NftDropRewardNotificationAddedSubscriptionDocument, options);
}